import React from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import WellnessGoals from './WellnessGoals';
import SectionLoadingError from "../common/SectionLoadingError";
import ReactPlayer from "react-player";
import * as types from "../../constants/actionTypes";
import { logUI } from '../../api/andyliticsApi';
import * as Tools from "../../helpers/Tools";

class WellBeingJourney extends React.Component {
    constructor(props) {
        super(props);
        const { wellnessDueDate } = this.props.serverData;
        this.currentYear = new Date(wellnessDueDate).getFullYear();
        const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        this.state = {
            showVideoLink: 'd-block d-md-none',
            videoClass: ' d-none d-md-block',
            videoPlaying: windowWidth && (windowWidth >= 768) ? true : false
        };
    }

    componentDidMount() {
        const { report } = this.props;
        if (!report) {
            this.props.getWellnessReportV2(this.props.userToken, this.currentYear);
            logUI("MBHWeb.UI.WellBeingDashboard.ComponentDidMount", new Date(), Tools.getURLPath());
        }      
    }

    showVideo = () => {
        this.setState({ showVideoLink: 'd-none', videoClass: '', videoPlaying: true });
    }

    render() {
        const { hasMyChartLogin, isProxyUser } = this.props;
        const { showVideoLink, videoClass, videoPlaying } = this.state;
        return (
            <div className="container-fluid body-content wellbeing-journey-container">
                {
                    isProxyUser ?
                        <SectionLoadingError message="We’re sorry, but this page is not available to you." sectionErrorClass="not-available-error" titleIcon="icon-log-out" />
                        :
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 d-none d-md-block">
                                        <h1 className="page-heading">Well-being Journeys</h1>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-9">
                                        <p className="sub-text">Start a Well-Being journey to track your health throughout the year. Enrolling in a journey is the first step. Please watch this video to learn more.</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className={`col-12 ${showVideoLink}`}>
                                        <Link className="link learn-more-link" onClick={this.showVideo} to="#">
                                            Learn More
                                            <span className="icon-video-camera" />
                                        </Link>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className={`col-md-6 col-lg-6 col-sm-12 ${videoClass}`}>
                                        <div className="well-being-journey__video">
                                            <ReactPlayer
                                                url="https://mediawadappsprod-use2.streaming.media.azure.net/e99953e4-670a-4cb0-a192-0d5bc4458e15/074fcc76313b4cd2b51943065fe27aff_640x360_AACAudio_244.mp4"
                                                playing={videoPlaying}
                                                controls
                                                width='100%'
                                                height='100%'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 well-being-journey__getStarted maxWidth-content">
                                <span>Get started below, or at anytime from your Well-being dashboard</span>
                            </div>

                            <div className="col-12 col-lg-12 maxWidth-content">
                                <div className="well-being-goals">
                                    <WellnessGoals currentYear={this.currentYear} />
                                </div>
                            </div>
                        </div>
                }
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        hasMyChartLogin: state.domain.hm,
        userToken: state.domain.t,
        report: state.thrive.report,
        serverData: state.session.serverData,
        isProxyUser: state.domain.ip
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getWellnessReportV2: (token, reportYear) => {
            dispatch({ type: types.THRIVE_GET_REPORT, token, reportYear });
        }
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WellBeingJourney));